import moment from "moment";
import { shuffle } from "lodash";

import template from "./ie-overlay.html";
import "./ie-overlay.less";
import edgeLogo from "../../images/edge-logo.svg";
import firefoxLogo from "../../images/firefox-logo.svg";
import chromeLogo from "../../images/chrome-logo.svg";

function controller($logger, $userProfile) {
	const ctrl = this;
	ctrl.dismiss = dismiss;
	ctrl.userProfile = $userProfile.getUserProfile();
	ctrl.browsers = makeBrowserList();
	ctrl.handleExternalNav = handleExternalNav;
	ctrl.isOpen = false;

	const buildIeOverlayEvent = $logger.buildWebEvent("ieOverlay");

	ctrl.$onInit = () => {
		const isIE = window.document.documentMode;
		if(isIE) {
			// hide banner if dismissed within the past day
			if(ctrl.userProfile.timeDismissed && moment()
				.subtract("days", 90)
				.isAfter(ctrl.userProfile.timeDismissed) ||
				!ctrl.userProfile.timeDismissed
			) {
				ctrl.isOpen = true;
			}
		}
	};

	function makeBrowserList() {
		const browserList = [{
			name: "Microsoft Edge",
			link: window.encodeURI("https://www.microsoft.com/en-us/edge"),
			logo: edgeLogo
		},
		{
			name: "Mozilla Firefox",
			link: window.encodeURI("https://www.mozilla.org/en-US/firefox/new/"),
			logo: firefoxLogo
		},
		{
			name: "Google Chrome",
			link: window.encodeURI("https://www.google.com/chrome/"),
			logo: chromeLogo
		}
		];
		return shuffle(browserList);
	}

	function dismiss() {
		$logger.event(buildIeOverlayEvent("dismiss")("clicked"), {
			via: "Accept Risk"
		});
		ctrl.userProfile.timeDismissed = moment().format();
		$userProfile.setUserProfile(ctrl.userProfile);

		ctrl.isOpen = false;
	}

	function handleExternalNav(type, name) {
		$logger.event(buildIeOverlayEvent("navigate")(type), {
			via: name
		});
	}
}


export default angular
	.module("vesl.components.ie-overlay", [])
	.component("ieOverlay", {
		template,
		controller
	}).name;
